export enum AdministrationLocationEnum {
    InternaInLoco = 1,
    ExternaCasa = 2
}